/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const MyGroup = zod.object({
  description: zod.string().nullable(),
  groupActorUuid: zod.uuid(),
  id: zod.string(),
  name: zod.string(),
  parentGroupActorUuid: zod
    .uuid()
    .nullable()
    .describe(
      'The parent, when this is a sub-group whose parent the caller can see; otherwise null.',
    ),
  permissions: zod
    .array(zod.string())
    .describe(
      "The caller's permission slugs in the group, including what its parent's Admin role brings.",
    ),
  subGroupCount: zod
    .int()
    .describe('How many of its sub-groups the caller can see; 0 for a sub-group.'),
  visibility: zod.enum(['PUBLIC', 'PRIVATE', 'SECRET']),
});

export type MyGroup = zod.input<typeof MyGroup>;
export type MyGroupOutput = zod.output<typeof MyGroup>;
